import { createSlice } from '@reduxjs/toolkit';

interface ResearchState {
  recentSearches: any[];
  isLoadingSearches: boolean;
  isSearching: boolean;
  totalCount: number;
  currentPage: number;
  pageSize: number;
  statusFilter: string | null;
  filterQuery: string | null;
  error: string | null;
}

const initialState: ResearchState = {
  recentSearches: [],
  isLoadingSearches: false,
  isSearching: false,
  totalCount: 0,
  currentPage: 1,
  pageSize: 10,
  statusFilter: null,
  filterQuery: null,
  error: null,
};

const researchSlice = createSlice({
  name: 'research',
  initialState,
  reducers: {
    // Add your research reducers here
  },
});

export default researchSlice.reducer;